import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Video = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="video icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M2.88 3.95569C1.28942 3.95569 0 5.24511 0 6.83569V17.3957C0 18.9863 1.28942 20.2757 2.88 20.2757H14.4C15.9906 20.2757 17.28 18.9863 17.28 17.3957V16.4104L21.1227 18.6207C22.4027 19.3569 24 18.433 24 16.9564V7.46137C24 5.94464 22.3241 5.02677 21.0461 5.84355L17.28 8.25043V6.83569C17.28 5.24511 15.9906 3.95569 14.4 3.95569H2.88Z"
    />
  </svg>
)
